import styled from "styled-components";
import Dropdown from "react-bootstrap/Dropdown";


export const StyledDropdown = styled(Dropdown)<{ disabled: boolean }>`
  > div {
    font-size: 12px;
    background-color: #E4E4E4;
  }

  > .dropdown-toggle::after {
    display: none;
  }

  .btn-primary {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    background-color: ${props => props.disabled ? "#AFAFAF" : props.theme.orangeBackground};
  }
`;

export const StyledDropDownToggle = styled(Dropdown.Toggle)`
  min-width: 158px;
  height: 29px;
  margin-right: 50px;
  padding-right: 36px;
  padding-left: 10px;
  border: none;
  border-radius: 3px;
  font-weight: 600;
  color: #fff;

  // Replace arrow
  appearance: none;
  background-image: url("data:image/svg+xml;charset=UTF-8,<svg width='17' height='11' viewBox='0 0 17 11' fill='none' xmlns='http://www.w3.org/2000/svg'> <path d='M1.9975 0.264404L8.5 6.75274L15.0025 0.264404L17 2.2619L8.5 10.7619L3.89524e-07 2.2619L1.9975 0.264404Z' fill='white'/> </svg>");
  background-repeat: no-repeat;
  background-position: right 10px center;
  background-size: 17px;
`;

export const StyledDropdownMenu = styled(Dropdown.Menu)`
  display: block;
  padding: 10px 10px;
  white-space: nowrap;
`;

export const StyledLabel = styled.label`
  display: flex;
  align-items: center;
  color: #808080;
  font-weight: 600;
  cursor: pointer;
  
  input {
    cursor: pointer;
  }
  
  span {
    margin-left: 8px;
  }
`;

export const SelectorsContainer = styled.div`
  display: flex;
  margin-top: 17px;
  color: #008566;
`;

export const SelectAll = styled.div`
  cursor: pointer;
`;

export const SelectNone = styled.div`
  cursor: pointer;
  margin-left: 20px;
`;
